import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
};

const accessKeysSlice = createSlice({
    name: "All Roadmap",
    initialState,
    reducers: {
        storeAccessKeys(state, action) {
            state.data = action.payload;
        },
        resetAccessKeys(state) {
            state.data = [];
        },
    },
});

export const {storeAccessKeys,resetAccessKeys} = accessKeysSlice.actions;

export default accessKeysSlice.reducer;